import { OpenClass, OpenClassStatus } from '../../openClasses/types/OpenClass';

// Full sessions stay selected, so the capacity check names the short day instead of quietly
// registering someone for part of a multi-day class.
export const getDefaultAssignableSessionIds = (
  openClass?: Pick<OpenClass, 'sessions'>,
): number[] =>
  (openClass?.sessions ?? [])
    .filter((session) => session.status !== OpenClassStatus.Canceled)
    .map((session) => session.id);

type SessionCapacity = Pick<
  OpenClass['sessions'][number],
  'capacity' | 'remainingCapacity'
>;

export const remainingSeats = (session: SessionCapacity): number =>
  session.remainingCapacity ?? session.capacity;

export const sessionSeatsSelection = (
  session: SessionCapacity,
  selectedCount: number,
): boolean => remainingSeats(session) >= selectedCount;
